import * as React from "react";
import { ResultFeatureInfo } from "./ResultFeatureInfo";
import { ExpandablePanel } from "./ExpandablePanel";
import { useState } from "react";
import { useAppContext } from "../../Contexts/AppContext";
import { useMapContext } from "../../Contexts/MapContext";
import { IdentifyResult, IdentifyResultsArray } from "./identifyUtils";
import "./Identify.scss";

export const IdentifyResults = ({ results }: { results: IdentifyResultsArray }): JSX.Element => {
    const { setHighlightFeatures } = useAppContext();
    const { configA } = useMapContext();
    const [expandedGroups, setExpandedGroups] = useState<number[]>([0]);
    const hasMultipleResults = results.length > 1 || results[0][1].length > 1;

    const onExpand = React.useCallback(
        (i: number, res: IdentifyResult) => {
            if (configA.identifyMultiExpand) {
                const newExpandedGroups = [...expandedGroups];
                newExpandedGroups.includes(i)
                    ? newExpandedGroups.filter((exp) => exp === i)
                    : newExpandedGroups.push(i);
                setExpandedGroups(newExpandedGroups);
            } else {
                setExpandedGroups([i]);
            }

            setHighlightFeatures([res.feature]);
        },
        [expandedGroups]
    );

    return (
        <>
            {hasMultipleResults ? (
                results.map((res, i) => (
                    <ExpandablePanel
                        key={"resultfeature" + i}
                        title={res[0]}
                        count={res[1].length.toString()}
                        isCollapsed={!expandedGroups.includes(i)}
                        onExpand={() => onExpand(i, res[1][0])}
                    >
                        {res[1].map((r, i) => (
                            <ResultFeatureInfo key={"resultinfo" + i} identified={r} />
                        ))}
                    </ExpandablePanel>
                ))
            ) : (
                <ExpandablePanel title={results[0][0]} notColapsable={true}>
                    <ResultFeatureInfo key={"resultinfo"} identified={results[0][1][0]} />
                </ExpandablePanel>
            )}
        </>
    );
};
